import styled from 'styled-components';

export const StorybookSpacerRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

export const StorybookSpacerColumn = styled.div<{ $center?: boolean }>`
    display: flex;
    gap: 10px;
    flex-direction: column;
    align-items: ${({ $center }) => ($center ? 'center' : 'flex-start')};
`;

export const StorybookHeading = styled.h3`
    color: ${(props) => props.theme.colors.white};
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.03em;
    text-decoration: underline;
`;

export const StorybookSubHeading = styled.h4`
    color: ${(props) => props.theme.colors.white};
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.03em;
`;
